import React from "react";
import "./Book.css";
const Book = (props) => {
  const { book, AddTimeToExercise } = props;
  const { name, image, price, time, writer } = book;

  return (
    <div className="col">
      <div className="card book p-2 border-0">
        <img
          src={image}
          alt=""
          className="img-fluid d-flex book-image rounded"
        />
        <div>
          <h6 className="card-title fw-bold mt-2 mb-3">{name}</h6>
          <h6>Price: Tk {price}</h6>
          <p className="p-0 m-0">Author: {writer}</p>
          <p className="p-0 mb-2">
            <small>Time required: {time} hours</small>
          </p>
        </div>
        <div>
          <button
            onClick={() => AddTimeToExercise(book)}
            className="btn btn-primary "
          >
            Add To List
          </button>
        </div>
      </div>
    </div>
  );
};

export default Book;
